export const interventionDAF = {
  purge_message: 'Purger toutes les données avant la date du',
};
